import React from 'react';
import {LMessages} from '../../Localization/Localization';
import {IPageInterface} from '../entity/IPageInterface';
import {ReportByStudentFields} from './fields';
import {createCommonRequest, ICommonRequest} from './ReportInterfaces';
import {UniversalReportPage} from './UniversalReportPage';

export const FullStudentReport = ({}: IPageInterface) => {
  return (
    <UniversalReportPage<ICommonRequest>
      action={'REPORT_FULL_STUDENTS'}
      emptyEntity={createCommonRequest()}
      fields={ReportByStudentFields}
      title={LMessages.REPORT_FULL_STUDENTS_CARD_TITLE}
    />
  );
};
